import styled from 'styled-components';

export const TimelineContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`;
